// Types
import { RootState } from 'types/RootState.types';

export const getGiftVoucherApplyGiftPaymentFailedSelector =
    (state: RootState) => state.giftVoucher?.applyGiftPaymentFailed ?? false;
export const getGiftVoucherErrorMessageSelector = (state: RootState) => state.giftVoucher?.errorMessage;
export const getGiftVoucherFormSubmitFailedSelector =
    (state: RootState) => state.giftVoucher?.formSubmitFailed ?? false;
export const getGiftVoucherIsLoadingSelector = (state: RootState) => state.giftVoucher?.isLoading ?? false;
